import { FastSearchActions } from './actions'
import { FastSearchGetters } from './getters'
import { FastSearchMutations } from './mutations'
import { FastSearchState } from './state'

export const FAST_SEARCH_NAMESPACE = 'fastSearch'

export const FastSearch = {
  namespaced: true,
  state: FastSearchState,
  actions: FastSearchActions,
  mutations: FastSearchMutations,
  getters: FastSearchGetters,
}
